var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9154_7088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0711 2.92895C15.1823 1.04016 12.6711 0 10 0C7.32895 0 4.8177 1.04016 2.92895 2.92895C1.04023 4.81773 0 7.32891 0 10C0 12.6711 1.04016 15.1823 2.92895 17.0711C4.81773 18.9598 7.32891 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32891 18.9598 4.81773 17.0711 2.92895ZM16.2417 16.2417C14.5745 17.9089 12.3579 18.8271 10.0001 18.8271C7.64227 18.8271 5.42563 17.9089 3.75844 16.2417C2.09113 14.5745 1.17297 12.3578 1.17297 10C1.17297 7.64223 2.09113 5.42559 3.75836 3.75832C5.42562 2.09109 7.64227 1.17293 10 1.17293C12.3578 1.17293 14.5745 2.09109 16.2417 3.75832C17.9089 5.42559 18.8271 7.64223 18.8271 10C18.8271 12.3578 17.9089 14.5745 16.2417 16.2417Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1649 5.08536C12.8881 4.91716 12.5274 5.0052 12.3592 5.28204C12.191 5.55888 12.2791 5.91962 12.5559 6.08778C13.2076 6.4838 13.7441 7.05485 14.1074 7.73931C14.4733 8.4288 14.6667 9.2379 14.6667 10.0792C14.6667 12.6524 12.5733 14.7458 10.0001 14.7458C7.42688 14.7458 5.33345 12.6523 5.33345 10.0791C5.33345 8.44888 6.16267 6.96345 7.55157 6.10552C7.82712 5.93528 7.91255 5.57395 7.74231 5.29833C7.57212 5.02278 7.21067 4.93735 6.93517 5.10759C6.10337 5.62138 5.40786 6.34165 4.92384 7.19048C4.42438 8.06645 4.1604 9.06528 4.1604 10.0791C4.1604 13.299 6.78001 15.9186 9.99997 15.9186C13.2199 15.9186 15.8395 13.299 15.8395 10.0791C15.8397 7.96989 14.8398 6.10302 13.1649 5.08536Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 3.87207C9.67615 3.87207 9.41357 4.13465 9.41357 4.45855V10.2857C9.41357 10.6096 9.67611 10.8721 10.0001 10.8721C10.324 10.8721 10.5865 10.6096 10.5865 10.2857V4.45852C10.5865 4.13465 10.3239 3.87207 10.0001 3.87207Z",
    fill: "#0A0F0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9154_7088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.bbbfdef4926989bcd0624f466d263b10.svg";
export { ForwardRef as ReactComponent };